import api from './api';
import type { Subscription, PaymentRecord } from '../types';

export const billingApi = {
  getSubscription: () =>
    api.get<{ subscription: Subscription | null; camera_count: number; price_per_camera: string; price_per_camera_excl_vat: string; normal_price_per_camera: string; normal_price_per_camera_excl_vat: string }>('/subscription').then((r) => r.data),

  getSubscriptionStatus: () =>
    api.get<{
      is_valid: boolean;
      status: string | null;
      days_until_expiry: number | null;
      grace_period_active: boolean;
      camera_count: number;
      total_amount: string | null;
    }>('/subscription/status').then((r) => r.data),

  generatePayment: () =>
    api.post<{ payment_url: string; payment_data: Record<string, string> }>('/payfast/payment/generate').then((r) => r.data),

  getPaymentHistory: () =>
    api.get<{ payments: PaymentRecord[] }>('/payfast/payment/history').then((r) => r.data.payments),

  cancelSubscription: (reason?: string) =>
    api.post<{ message: string; payfast_cancelled: boolean; access_until: string }>('/payfast/subscription/cancel', { reason }).then((r) => r.data),

  submitPayFastForm: (paymentData: Record<string, string>, paymentUrl: string) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = paymentUrl;
    Object.entries(paymentData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = String(value);
        form.appendChild(input);
      }
    });
    document.body.appendChild(form);
    form.submit();
  },
};
